import script from "./homeVue.vue?vue&type=script&setup=true&lang=js"
export * from "./homeVue.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/welcome.css?vue&type=style&index=0&lang=css&external"
import "../assets/css/header.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__